module.exports = __webpack_public_path__ + "img/header-weddingRingsSlim@2x.6358d9f.webp";